var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkillsDePts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79 79",
    style: {
      enableBackground: "new 0 0 79 79"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#061E26;}\n\t.st1{fill:#26C9FF;}\n\t.st2{fill:#D9F5FF;stroke:#D9F5FF;stroke-width:2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 79,
    height: 79
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75,4v71H4V4H75 M79,0H0v79h79V0L79,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.1,31.5c0,3.6-1.2,6.4-3.7,8.3c-2.5,1.9-6,2.9-10.6,2.9h-4.2v14h-4.2V21.1h9.3 C34.7,21.1,39.1,24.6,39.1,31.5z M20.6,39.2h3.7c3.7,0,6.3-0.6,8-1.8c1.6-1.2,2.5-3.1,2.5-5.7c0-2.4-0.8-4.1-2.3-5.3 c-1.5-1.2-4-1.7-7.2-1.7h-4.6V39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.2,49.5c0,2.5-0.9,4.4-2.8,5.8c-1.9,1.4-4.5,2-7.8,2c-3.5,0-6.3-0.6-8.3-1.7v-3.8c1.3,0.7,2.7,1.2,4.1,1.5 c1.5,0.4,2.9,0.6,4.3,0.6c2.1,0,3.7-0.3,4.9-1c1.1-0.7,1.7-1.7,1.7-3.1c0-1-0.5-1.9-1.4-2.7c-0.9-0.7-2.7-1.6-5.3-2.6 c-2.5-0.9-4.3-1.7-5.3-2.4c-1-0.7-1.8-1.5-2.3-2.4s-0.8-1.9-0.8-3.1c0-2.2,0.9-3.9,2.7-5.2c1.8-1.3,4.2-1.9,7.3-1.9 c2.9,0,5.7,0.6,8.4,1.8l-1.4,3.3c-2.7-1.1-5.1-1.7-7.3-1.7c-1.9,0-3.4,0.3-4.3,0.9c-1,0.6-1.5,1.4-1.5,2.5c0,0.7,0.2,1.3,0.5,1.8 c0.4,0.5,1,1,1.8,1.4c0.8,0.5,2.4,1.1,4.7,2c3.2,1.2,5.3,2.3,6.4,3.5C62.7,46.3,63.2,47.7,63.2,49.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsDePts);
export default __webpack_public_path__ + "static/media/skills-de_pts.3b7156a4525d527ed89cb74b07aa802a.svg";
export { ForwardRef as ReactComponent };